import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, PointElement,
  LineElement, Title, Tooltip, Legend, Filler,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

export default function EquityChart({ snapshots = [], height = 300 }) {
  const labels = snapshots.map(s => {
    const d = new Date(s.date);
    return `${d.getMonth() + 1}/${d.getDate()}`;
  });

  const data = {
    labels,
    datasets: [
      {
        label: 'Equity',
        data:  snapshots.map(s => s.equity),
        borderColor: '#1d8cf8',
        backgroundColor: 'rgba(29, 140, 248, 0.1)',
        fill: true,
        tension: 0.4,
        pointRadius: 2,
      },
      {
        label: 'Balance',
        data:  snapshots.map(s => s.balance),
        borderColor: '#00d6b4',
        backgroundColor: 'transparent',
        tension: 0.4,
        pointRadius: 2,
        borderDash: [5, 5],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { labels: { color: '#9a9a9a' } },
      tooltip: { mode: 'index', intersect: false },
    },
    scales: {
      x: { ticks: { color: '#9a9a9a' }, grid: { color: 'rgba(255,255,255,0.05)' } },
      y: { ticks: { color: '#9a9a9a' }, grid: { color: 'rgba(255,255,255,0.05)' } },
    },
  };

  if (!snapshots.length) {
    return <p className="text-muted text-center py-4">No performance data available.</p>;
  }

  return (
    <div style={{ height }}>
      <Line data={data} options={options} />
    </div>
  );
}
